import { Card, Statistic, Typography } from "antd";
import React from "react";

const CardChart = ({ listingChart, chartinfo }) => {
  return listingChart?.map((x) => (
    <Card size="small">
      <Statistic
        title={
          <Typography.Title level={5} className=" mt-2 ms-2   text-secondary">
            {chartinfo?.chart_title}
          </Typography.Title>
        }
        value={x?.value}
        precision={0}
        valueStyle={{ color: "#f39c12" }}
      />
    </Card>
  ));
};

export default CardChart;
